import { forwardRef, useState } from 'react';

import { useMe } from '@crehana/auth';
import { Timeline } from '@crehana/compass.dashlets/timeline';

import { useGetTimeline } from '../hooks/use-get-timeline';

const TimelineWidget = forwardRef<HTMLDivElement>(
  (_, ref: React.ForwardedRef<HTMLDivElement>) => {
    const currentDate = new Date();
    const [month, setMonth] = useState<number>(new Date().getMonth());
    const [year, setYear] = useState<number>(currentDate.getFullYear());
    const { talentUser } = useMe();

    const {
      loading: loadingTimeline,
      dataTimeLine,
      error: errorTimeline,
      refetch: retryTimeline,
    } = useGetTimeline({
      month,
      year,
    });

    return (
      <div ref={ref} className="tw-w-full tw-h-full">
        <Timeline
          isLoading={loadingTimeline}
          timeline={dataTimeLine}
          year={year}
          month={month}
          changeMonth={setMonth}
          changeYear={setYear}
          isBoss={talentUser.is_boss}
          error={!!errorTimeline}
          retry={retryTimeline}
        />
      </div>
    );
  },
);

TimelineWidget.displayName = 'TimelineWidget';

export { TimelineWidget };
